import type { ReactNode } from "react";
import { Link } from "wouter";
import { useAuth } from "../lib/auth";
import { useT, type MessageKey } from "../lib/i18n";
import { Button } from "@/components/ui/button";

/**
 * Renders children when logged in, otherwise a "log in to do this" card.
 * `action` is a `gateAction.*` message key describing the gated action
 * ("log an outing", "edit an outing", …) — translated here, not by callers.
 */
export function LoginGate({ action, next, children }: { action: MessageKey; next: string; children: ReactNode }) {
  const { personId } = useAuth();
  const { t } = useT();
  if (personId) return <>{children}</>;
  return (
    <div className="mx-auto m-4 max-w-md rounded-xl border border-alpine-200 dark:border-alpine-900 bg-alpine-50 dark:bg-alpine-950 p-6 text-center shadow-card">
      <p className="mb-5 text-sm text-foreground">{t("gate.needAccount", { action: t(action) })}</p>
      <div className="flex justify-center gap-3">
        <Button asChild>
          <Link href={`/login?next=${encodeURIComponent(next)}`}>{t("common.logIn")}</Link>
        </Button>
        <Button variant="outline" asChild>
          <Link href={`/register?next=${encodeURIComponent(next)}`}>{t("common.register")}</Link>
        </Button>
      </div>
    </div>
  );
}
